<template>
  <div>
    <!-- <div class="row justify-content-between align-items-center">
      <div class="col-md-3 customHeading">
        <h3>{{ moduleName }}</h3>
      </div>

      <div class="col-md-3">
        <b-form-group
          label="Start Date"
          label-for="datepicker-1"
          autocomplete="off"
        >
          <b-form-datepicker
            id="datepicker-1"
            v-model="StartDate"
            placeholder="Choose a date"
            local="en"
            @input="getShipmentReport()"
            required
          ></b-form-datepicker>
        </b-form-group>
      </div>
      <div class="col-md-3">
        <b-form-group
          label="End Date"
          label-for="datepicker-2"
          autocomplete="off"
        >
          <b-form-datepicker
            id="datepicker-2"
            v-model="EndDate"
            placeholder="Choose a date"
            local="en"
            @input="getShipmentReport()"
            required
          ></b-form-datepicker>
        </b-form-group>
      </div>

      <div class="col-md-3">
        <b-form-group
          label="Transactions"
          label-for="isInventory"
          autocomplete="off"
        >
          <b-form-select
            id="isinventory"
            v-model="IsInventory"
            :options="inventoryOptions"
            class="class-dropdown"
            @change="getShipmentReport()"
          ></b-form-select>
        </b-form-group>
      </div>
    </div> -->

    <div class="com-header">
      <div
        class="custom-row custom-options-menu justify-content-between align-items-center"
      >
        <div class="customHeading">
          <nav>
            <div
              class="nav nav-tabs custom-nav-tabs"
              id="nav-tab"
              role="tablist"
            >
              <a
                class="nav-item nav-link custom-nav-link active"
                id="nav-table-tab"
                data-toggle="tab"
                href="#nav-table"
                role="tab"
                aria-controls="nav-table"
                aria-selected="true"
              >
                <span> {{ moduleName }} </span>
              </a>
            </div>
          </nav>
        </div>
        <div class="">
          <div class="custom-icons-group">
            <div class="custom-row w3-center custom-filter-section no-gutters">
              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="Start Date"
                  label-for="datepicker-1"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-1"
                    v-model="StartDate"
                    placeholder="Choose a date"
                    local="en"
                    @input="getShipmentReport()"
                    required
                    size="sm"
                  ></b-form-datepicker>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="End Date"
                  label-for="datepicker-2"
                  autocomplete="off"
                >
                  <b-form-datepicker
                    id="datepicker-2"
                    v-model="EndDate"
                    placeholder="Choose a date"
                    local="en"
                    @input="getShipmentReport()"
                    required
                    size="sm"
                  ></b-form-datepicker>
                </b-form-group>
              </div>

              <div
                class="custom-btn"
                data-toggle="tooltip"
                data-placement="top"
                title="Filters"
              >
                <b-form-group
                  label="Transactions"
                  label-for="isInventory"
                  autocomplete="off"
                >
                  <b-form-select
                    id="isinventory"
                    v-model="IsInventory"
                    :options="inventoryOptions"
                    class="class-dropdown"
                    @change="getShipmentReport()"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="custom-accordion-separator">
      <div class="custom-separator"></div>
    </div>

    <div>
      <div class="row">
        <div class="col">
          <table
            class="table table-striped table-borderless cutom-table table-striped table-sm"
            style="font-size: 85%;"
          >
            <thead>
              <tr>
                <th role="columnheader">&nbsp;</th>
                <th v-for="weight in weights" :key="weight.id">
                  {{ weight.weight }}
                </th>
                <th role="columnheader">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-if="productionData == null || productionEntries.length == 0"
              >
                <td colspan="4" class="center-td">No Data</td>
              </tr>

              <tr
                v-else
                v-for="rec in productionEntries"
                :key="rec.flourTypeId"
              >
                <td role="cell" class="report-first-td">
                  {{ rec.flourTypeName }}
                </td>
                <td
                  role="cell"
                  v-for="item in rec.productionDetails"
                  :key="item.flourWeightTypeLinkId"
                >
                  <span v-if="item.noOfSacks > 0 || item.kGs > 0">
                    {{ item.noOfSacks }} &nbsp;Sacks {{ item.kGs }} &nbsp;KGs
                    {{ item.tons }} &nbsp;TONs
                  </span>
                  <span v-else>-</span>
                </td>
                <td>
                  {{ rec.totalKGs }}&nbsp;KGs {{ rec.totalTons }}&nbsp;TONs
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--PAGINATION START-->
      <div class="row justify-content-between align-items-center">
        <div class="col-md-2">
          <div class="showPages">
            <select
              class="form-control"
              id="selClass"
              v-model="perPage"
              @change="getShipmentReport()"
            >
              <option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-8 d-flex justify-content-center">
          <div class="overflow-auto">
            <b-pagination
              v-model="page"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              @change="getPage"
            ></b-pagination>
          </div>
        </div>

        <div class="col-md-2">
          <input
            class="form-control search-box page-no-search"
            type="text"
            v-bind:placeholder="page"
            aria-label="search"
            v-model.number="pageNumOnSearch"
            style="height:38px"
          />

          <button
            class="search-button btn btn-primary search page-no-search-btn"
            @click="search()"
          >
            GO
          </button>
        </div>
      </div>
      <!--/PAGINATION END-->
      <!--SPINNER-->
      <Spinner
        v-if="isLoading"
        message="Loading..."
        size="medium"
        line-fg-color="rgb(222 224 219"
        line-bg-color="rgb(68 66 62)"
      >
      </Spinner>
      <!--/SPINNER-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import config from '../config.js';
import Spinner from "vue-simple-spinner";

export default {
  name: "ShipmentReport",
  data() {
    return {
      moduleName: "Shipment Report",
      isLoading: false,

      inventoryOptions: [
        { value: true, text: "Inventory" },
        { value: false, text: "Non Inventory" },
        { value: null, text: "All" },
      ],
      IsInventory: null,

      StartDate: new Date(),
      EndDate: new Date(),
      productionData: null,
      productionEntries: null,
      weights: null,
      pageNumOnSearch: "",
      filteredText: "",
      rows: 0,
      page: 1,
      options: [
        { text: "Show 2", value: 2 },
        { text: "Show 10", value: 10 },
        { text: "Show 25", value: 25 },
        { text: "Show 50", value: 50 },
        { text: "Show 100", value: 100 },
      ],
      perPage: 25,
    };
  },

  methods: {
    getPage(page) {
      this.page = page;
      this.getShipmentReport();
    },

    getShipmentReport() {
      this.isLoading = true;
      axios
        .post("/productionreport/getallShipments", {
          UserId: this.$auth.user().id,
          CompanyId: this.$auth.user().companyId,
          PageSize: this.perPage,
          Page: this.page,
          FromDate: this.StartDate,
          ToDate: this.EndDate,
          IsInventory: this.IsInventory,
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.status == 1) {
            // console.log(res.data)
            this.productionData = res.data.data;
            this.weights = this.productionData.flourWeights;
            this.productionEntries = this.productionData.records;
            this.rows = res.data.totalRecords;
          } else if (res.data.status == 0) {
            this.productionData = null;
          } else if (res.data.status == -1) {
            this.$bvModal.msgBoxOk(res.data.msg, {
              title: "Error",
              size: "sm",
              buttonSize: "sm",
              okVariant: "danger",
              headerClass: "p-10 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            });
          }
          this.isLoading = false;
        });
    },

    search() {
      this.page = this.pageNumOnSearch;
      this.getShipmentReport();
    },
  },
  created() {
    var date = new Date();
    this.StartDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      1,
      this.StartDate.getHours()
    );
    // console.log(this.StartDate)
    // this.StartDate.setFullYear(date.getFullYear(), date.getMonth(), 1)
    this.EndDate = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      0,
      this.EndDate.getHours()
    );
    // console.log(this.EndDate)
    // this.EndDate.setFullYear(date.getFullYear(), date.getMonth() + 1, 0);
    this.getShipmentReport();
    // this.getStudents();
    //localStorage.setItem("mytime", Date.now());
  },
  components: {
    Spinner,
  },
};
</script>

<style scoped>
button.page-link {
  display: inline-block;
}
button.page-link {
  font-size: 20px;
  color: #29b3ed;
  font-weight: 500;
}
.offset {
  width: 500px !important;
  margin: 20px auto;
}
select#class-dropdown {
  width: 80%;
  margin-left: 16%;
}
.custom-row {
  overflow: visible !important;
}
.form-group {
  margin-bottom: 0.4rem;
}
</style>
